import {
  REQUEST_SERVICE_HISTORY,
  RESPONSE_SERVICE_HISTORY,
  REQUEST_SERVICE_HISTORY_FAILURE,
  REQUEST_CREATE_SERVICE_HISTORY_COMMENTARY,
  RESPONSE_CREATE_SERVICE_HISTORY_COMMENTARY,
  REQUEST_CREATE_SERVICE_HISTORY_COMMENTARY_FAILURE,
  REQUEST_SERVICE_HISTORY_ACTIONS,
  RESPONSE_SERVICE_HISTORY_ACTIONS,
  REQUEST_SERVICE_HISTORY_ACTIONS_FAILURE,
} from "../actions/serviceHistoryActions";

import { states } from "./queriesStates";

const initialState = {
  dataState: states.NOT_REQUESTED,
  serviceHistoryActionsDataState: states.NOT_REQUESTED,
  createServiceHistoryCommentDataState: states.NOT_REQUESTED,
  serviceHistory: null,
  serviceHistoryTotalCount: 0,
  serviceHistoryActions: [],
};

const serviceHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_SERVICE_HISTORY:
      return Object.assign({}, state, {
        dataState: states.REQUEST,
        serviceHistory: null,
      });
    case RESPONSE_SERVICE_HISTORY:
      return Object.assign({}, state, {
        dataState: states.READY,
        serviceHistory: action.data,
        serviceHistoryTotalCount: action.data.totalCount,        
        serviceHistoryCount: action.data.count,
      });
    case REQUEST_SERVICE_HISTORY_FAILURE:
      return Object.assign({}, state, {
        dataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_CREATE_SERVICE_HISTORY_COMMENTARY:
      return Object.assign({}, state, {
        createServiceHistoryCommentDataState: states.REQUEST,
      });
    case RESPONSE_CREATE_SERVICE_HISTORY_COMMENTARY:
      const serviceHistory = state.serviceHistory;

      serviceHistory.actions.forEach((item) => {
        if (item.id === action.serviceHistoryId) {
          item.commentaries = item.commentaries.concat([action.data]);
          item.commentariesCount += 1;
        }
      });

      return Object.assign({}, state, {
        createServiceHistoryCommentDataState: states.READY,
        serviceHistory: serviceHistory,
      });
    case REQUEST_CREATE_SERVICE_HISTORY_COMMENTARY_FAILURE:
      return Object.assign({}, state, {
        createServiceHistoryCommentDataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_SERVICE_HISTORY_ACTIONS:
      return Object.assign({}, state, {
        serviceHistoryActionsDataState: states.REQUEST,
      });
    case RESPONSE_SERVICE_HISTORY_ACTIONS:
      return Object.assign({}, state, {
        serviceHistoryActionsDataState: states.READY,
        serviceHistoryActions: action.data.actions,
      });
    case REQUEST_SERVICE_HISTORY_ACTIONS_FAILURE:
      return Object.assign({}, state, {
        serviceHistoryActionsDataState: states.FAILURE,
        errors: action.errors,
      });

    default:
      return state;
  }
};

export default serviceHistoryReducer;
